import React from 'react';

const CTA_UTM_SOURCE = "salongrowthcalc";
const DISCOVERY_CALL_URL = `https://meetings.hubspot.com/cmahoney1/discovery-call?uuid=77a54f06-1a54-4b2d-80e5-c5b95383ea0f&utm_source=${CTA_UTM_SOURCE}&utm_medium=cta&utm_campaign=cta_2026q2`;
const SALON_IQ_URL = `https://saloniq.summitsalon.com/?utm_source=${CTA_UTM_SOURCE}&utm_medium=cta&utm_campaign=cta_2026q2`;

function CTABlock() {
    return (
        <div className="cta-section">
            <p className="cta-heading">Ready to grow your salon?</p>
            <p className="cta-subheading">Talk to a Summit Salon coach or take the full Salon IQ assessment.</p>
            <a
                href={DISCOVERY_CALL_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button cta-primary"
            >
                Book a Complimentary Discovery Call
            </a>
            <a
                href={SALON_IQ_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button cta-secondary"
            >
                Complete Salon IQ Assessment
            </a>
        </div>
    );
}

export default CTABlock;
